import React from 'react';
import * as Sebrae from '@sebrae/react-core';
import DOMPurify from 'dompurify';

import {
  BaSeButton,
  BaSeHeading4,
  BaSeIcon,
  BaSeParagraph,
  BaSeTheme,
} from '@base/react';
import {
  ContentCertificate,
  ResultSearchCertificate,
  WrapperButtonCertificate,
} from './resultado-styled';

const UpperCase = ({ text }) => {
  return <strong>{text.toUpperCase()}</strong>;
};

export const ResultadoValido = ({ certificadoDetalhes }) => {
  const { navigateTo } = Sebrae.useRouter();
  const { azulSebrae36 } = BaSeTheme.colors.institucionais;
  const { sucesso20 } = BaSeTheme.colors.feedbackInterface;

  function dataConsulta() {
    var now = new Date();
    var months = [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ];
    return `${now.getDate()} de ${
      months[now.getMonth()]
    } de ${now.getFullYear()}`;
  }

  const url = certificadoDetalhes.url;

  return (
    <ResultSearchCertificate>
      <BaSeIcon
        name="shield-check"
        description="certificado valido"
        color={sucesso20}
      />
      <BaSeHeading4 isBold>CERTIFICADO AUTÊNTICO</BaSeHeading4>
      {imprimeCertificadoPadrao(certificadoDetalhes)}

      <BaSeParagraph>{imprimeConteudo(certificadoDetalhes)}</BaSeParagraph>

      <BaSeParagraph>Brasília, {dataConsulta()}</BaSeParagraph>
      <WrapperButtonCertificate>
        <BaSeButton
          buttonType="button"
          color={azulSebrae36}
          onClick={() => window.open(url, '_blank')}
          size="medium"
          type="primary"
          value="Baixar o certificado"
          width="176"
        />
        <BaSeButton
          buttonType="button"
          color={azulSebrae36}
          onClick={() => navigateTo(`/`)}
          size="medium"
          type="secondary"
          value="Voltar"
          width="176"
        />
      </WrapperButtonCertificate>
    </ResultSearchCertificate>
  );
};

export const imprimeCertificadoPadrao = (certificadoDetalhes) => {
  const textValidationHtmlString = DOMPurify.sanitize(certificadoDetalhes?.textoValidacao ?? '');
  return (
    <ContentCertificate>
      <div dangerouslySetInnerHTML={{ __html: textValidationHtmlString }} />
    </ContentCertificate>
  );
};

export const imprimeCertificadoEmpretec = (certificadoDetalhes) => {
  return (
    <BaSeParagraph>
      Certificamos que <UpperCase text={certificadoDetalhes.nome} />, CPF nº{' '}
      <UpperCase text={certificadoDetalhes.cpf} />, participou do evento{' '}
      <strong> EMPRETEC REALIZA</strong>, promovido pelo{' '}
      <strong> SEBRAE</strong>, nos dias{' '}
      <strong> {getDiaFromDateString(certificadoDetalhes.dataInicio)}</strong> e{' '}
      <strong> {getDataPorExtenso(certificadoDetalhes.dataFim)}</strong>, com
      carga horária total de{' '}
      <strong> {certificadoDetalhes.cargaHoraria}</strong> .
      <br />
    </BaSeParagraph>
  );
};

export const imprimeConteudo = (certificadoDetalhes) => {
  return certificadoDetalhes.descricaoConteudo != null &&
    certificadoDetalhes.descricaoConteudo !== '' ? (
    <>
      <span>{certificadoDetalhes.descricaoConteudo}</span>
      {certificadoDetalhes.composicaoConteudo != null ? (
        <ul>
          {certificadoDetalhes.composicaoConteudo.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      ) : (
        <></>
      )}
    </>
  ) : (
    <></>
  );
};

export const getDiaFromDateString = (dateString) => {
  const dateSplit = dateString.split('/');
  return dateSplit[0];
};

export const getDataPorExtenso = (dateString) => {
  const dateParts = dateString.split('/');

  const date = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);

  return (
    <>
      {date.getDate()} de {mesesEmPortugues[date.getMonth()]} de{' '}
      {date.getFullYear()}
    </>
  );
};

const mesesEmPortugues = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];

export const imprimeData = (certificadoDetalhes) => {
  return certificadoDetalhes.dataInicio != null &&
    certificadoDetalhes.dataInicio !== '' ? (
    <>
      {' '}
      período de <strong> {certificadoDetalhes.dataInicio}</strong> a{' '}
      <strong> {certificadoDetalhes.dataFim}</strong>
    </>
  ) : (
    <>
      {' '}
      dia <strong> {certificadoDetalhes.dataFim}</strong>
    </>
  );
};
